// @flow
import required from './required';

/**
 * Returns a validation error if value doesn't look like a real verification code
 * @param value
 * @returns {string}
 */
export default (value: any): ?string => {
    if (typeof Stripe === 'undefined') {
        throw new Error('Stripe.js client library not loaded!!');
    }

    const requiredError = required(value);
    if (requiredError) return;

    const invalid = !Stripe.card.validateCVC(value);
    if (invalid) {
        return 'invalidCVC';
    }
};
